import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { colors } from '../../../../../../../constants/colors';
import { fontSize, fontFamily } from '../../../../../../../constants/text';
import WarningIcon from '../../../../../../SolvPatternLibrary/Icons/WarningWhiteBorder';
import PeakTimeAlert from '../../../PeakTimeAlert';
import Tooltip from '../../../../../../SolvPatternLibrary/Tooltip';

const Container = styled.div`
  position: relative;
  background-color: ${colors.crunchBerry};
  color: ${colors.theWhiteAlbum};
  font-family: ${fontFamily.bold};
  font-size: ${fontSize.small};
  letter-spacing: -0.13px;
  line-height: 16px;
  text-align: center;
  width: 74px;
  padding: 7px 0;
  cursor: pointer;
  box-sizing: border-box;
  transition: color 200ms ease, background-color 200ms ease;
  border-radius: 4px;
  border: 1px solid ${colors.crunchBerry};
  
  ${props =>
    props.darkTheme &&
    css`
      border-color: #dee6eb;
      color: ${colors.myRightFoot};
    `}

  ${props =>
    props.isSelected &&
    css`
      background-color: ${colors.theWhiteAlbum};
      color: ${colors.crunchBerry};
      border: 1px solid ${colors.crunchBerry};
    `}
  ${props =>
    !props.isAvailable &&
    !props.isSelected &&
    css`
      border: 1px solid ${colors.fatherJohnMisty};
      color: ${colors.greyWorm};
      cursor: default;
      background-color: ${colors.fatherJohnMisty};
    `}
  ${props =>
    props.isAvailable &&
    !props.isSelected &&
    css`
      &:hover {
        background-color: ${colors.theWhiteAlbum};
        color: ${colors.crunchBerry};
        border: 1px solid ${colors.crunchBerry};
      }
    `}
`;

const StyledWarningIcon = styled(WarningIcon)`
  position: absolute;
  top: -8px;
  right: -8px;
  font-size: 18px;
`;

class TimeSlot extends PureComponent {
  render() {
    const {
      isSelected,
      isAvailable,
      shouldShowSlotAsBusy,
      time,
      className,
      onSelect,
      showBusyTooltip,
      darkTheme,
    } = this.props;

    const WarningWrapper = showBusyTooltip ? Tooltip : 'span';

    return (
      <Container
        isSelected={isSelected}
        isAvailable={isAvailable}
        darkTheme={darkTheme}
        shouldShowSlotAsBusy={shouldShowSlotAsBusy}
        className={className}
        onClick={onSelect}
      >
        {time}
        {shouldShowSlotAsBusy && (
          <WarningWrapper
            showInfoIcon={false}
            title={showBusyTooltip ? <PeakTimeAlert slot={{ isBusy: true }} /> : undefined}
          >
            <StyledWarningIcon />
          </WarningWrapper>
        )}
      </Container>
    );
  }
}

TimeSlot.propTypes = {
  isSelected: PropTypes.bool,
  isAvailable: PropTypes.bool,
  shouldShowSlotAsBusy: PropTypes.bool,
  time: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  className: PropTypes.string,
  darkTheme: PropTypes.bool,
  onSelect: PropTypes.func,
  classes: PropTypes.object,
  showBusyTooltip: PropTypes.bool,
};

export default TimeSlot;
